export default __webpack_public_path__ + "static/media/pexels-karolina-grabowska-7195123.4c4fcb24.jpg";